import type { JoinErrorKind } from './types'

export function resumeFailureAction(kind: JoinErrorKind): 'keep_and_rejoin' | 'clear_and_fail' | 'wait' {
  if (kind === 'waiting_for_class') return 'wait'
  if (kind === 'network' || kind === 'unavailable' || kind === 'unknown') return 'keep_and_rejoin'
  return 'clear_and_fail'
}
